<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Post Graduate Programs</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">Post Graduate Programs</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="section-lg">
    <div class="container">
        <div class="program-container">
              <div class="item ">
        <div class="program-card">
          <div class="program-img">
            <img loading="lazy" src="{{baseUrl1}}/courses/bachelor-of-B-administration.webp"
              alt="Master of Commerce | GHRCACS, PUNE" class="w-100" />
          </div>
          <div class="program-details">
            <div class="d-flex align-items-start justify-content-between">
              <div class="sec-thirdtitle w-75 text-start">
                <h5 class="text-black">Master of Commerce</h5>
              </div>
              <div class="share-img w-auto text-end">
                <a href="#"><img loading="lazy" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/share.webp"
                    alt="GHRCACS, PUNE" class="img-fluid"></a>
              </div>
            </div>
            <div class="pro-year w-auto d-lg-flex justify-content-between justify-content-lg-start d-md-flex">
              <div>
                <i class="fa fa-calendar-o"></i>
                <span>2 Years</span>
              </div>
              <div>
                <i class="fa-regular fa-clock ms-lg-3" aria-hidden="true"></i>
                <span>Full Time</span>
              </div>
            </div>
            <div class="d-flex justify-content-between"><a routerLink="/m-com" class="cmn-white-button">Learn More</a>
              <a href="https://raisoni.nopaperforms.com/rgi" target="_blank" class="cmn-button">Apply Now</a>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="item ">
        <div class="program-card">
          <div class="program-img">
            <img loading="lazy" src="{{baseUrl1}}/courses/master-of-science.webp" alt="Master of Science | GHRCACS, PUNE" class="w-100" />
          </div>
          <div class="program-details">
            <div class="d-flex align-items-start justify-content-between">
              <div class="sec-thirdtitle w-75 text-start">
                <h5 class="text-black">Master of <br> Science</h5>
              </div>
              <div class="share-img w-auto text-end">
                <a href="#"><img loading="lazy" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/share.webp"
                    alt="GHRCACS, PUNE" class="img-fluid"></a>
              </div>
            </div>
            <div class="pro-year w-auto d-lg-flex justify-content-between justify-content-lg-start d-md-flex">
              <div>
                <i class="fa fa-calendar-o"></i>
                <span>2 Years</span>
              </div>
              <div>
                <i class="fa-regular fa-clock ms-lg-3" aria-hidden="true"></i>
                <span>Full Time</span>
              </div>
            </div>
            <div class="d-flex justify-content-between"><a routerLink="/pg-msc" class="cmn-white-button">Learn More</a>
              <a href="https://raisoni.nopaperforms.com/rgi" target="_blank" class="cmn-button">Apply Now</a>
            </div>
          </div>
        </div>
      </div> -->
      <div class="item ">
        <div class="program-card">
          <div class="program-img">
            <img loading="lazy" src="{{baseUrl1}}/courses/master-of-commerce.webp"
              alt="M.Sc Computer Science | GHRCACS, PUNE" class="w-100" />
          </div>
          <div class="program-details">
            <div class="d-flex align-items-start justify-content-between">
              <div class="sec-thirdtitle w-75 text-start">
                <h5 class=" text-black"> M.Sc Computer <br> Science</h5>
              </div>
              <div class="share-img w-auto text-end">
                <a href="#"><img loading="lazy" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/share.webp"
                    alt="GHRCACS, PUNE" class="img-fluid"></a>
              </div>
            </div>
            <div class="pro-year w-auto d-lg-flex justify-content-between justify-content-lg-start d-md-flex">
              <div>
                <i class="fa fa-calendar-o"></i>
                <span>2 Years</span>
              </div>
              <div>
                <i class="fa-regular fa-clock ms-lg-3" aria-hidden="true"></i>
                <span>Full Time</span>
              </div>
            </div>
            <div class="d-flex justify-content-between"><a routerLink="/msc-computer-science"
                class="cmn-white-button">Learn More</a>
              <a href="https://raisoni.nopaperforms.com/rgi" target="_blank" class="cmn-button">Apply Now</a>
            </div>
          </div>
        </div>
      </div>
        </div>
    </div>
</section>